"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateLpConfigurationVersion = void 0;
const utils_1 = require("../utils");
const v2_1 = require("./v2");
const v3_1 = require("./v3");
const v4_1 = require("./v4");
const v5_1 = require("./v5");
const v6_1 = require("./v6");
exports.updateLpConfigurationVersion = (0, utils_1.createVersionUpdater)("Landing Page", [
    { version: 1, updater: v2_1.updateVersion1toVersion2 },
    { version: 2, updater: v3_1.updateVersion2toVersion3 },
    { version: 3, updater: v4_1.updateVersion3toVersion4 },
    { version: 4, updater: v5_1.updateVersion4toVersion5 },
    { version: 5, updater: v6_1.updateVersion5toVersion6 },
    { version: 6, updater: (configuration) => configuration }
]);
//# sourceMappingURL=updateVersion.js.map